import type { RouteObject } from "react-router";
import { POST_ROUTES } from "../constants/post-routes";

export const postRoutes: RouteObject = {
	children: [
		{
			path: POST_ROUTES.FEED,
			lazy: async () => {
				const { default: PostFeedPage } = await import("../pages/post-feed-page");
				return { Component: PostFeedPage };
			},
		},
		{
			path: POST_ROUTES.DRAFTS,
			lazy: async () => {
				const { default: DraftsPage } = await import("../pages/drafts-page");
				return { Component: DraftsPage };
			},
		},
		{
			path: POST_ROUTES.SAVED,
			lazy: async () => {
				const { default: SavedPage } = await import("../pages/saved-page");
				return { Component: SavedPage };
			},
		},
		{
			path: POST_ROUTES.DETAIL,
			lazy: async () => {
				const { default: PostDetailPage } = await import("../pages/post-detail-page");
				return { Component: PostDetailPage };
			},
		},
	],
};
